import React from 'react';
import { ImageView, VideoView } from '../../components';
export function MediaRenderer({ media }) {
    return (media.type || 'image') === 'image' ? (React.createElement(ImageView, { media: media })) : (React.createElement(VideoView, { media: media }));
}
